/**
 * The below file contains the fire class state objects
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import { AUTH_TOKEN } from "redux/constants/Auth";
import {
  SET_ALL_FIRE_CLASS,
} from "redux/constants/FireClass";

//Initial state
const initState = {
  // Keys for dropdown 
  fireClasses: [],
  isFireClassDataFetched: false,
  // Keys for dropdown 
};

/**
 * The below function will update the state on the basis of action type.
 * @param {any} state State
 * @param {any} action Action
 * @returns Json object
 */
const fireClass = (state = initState, action) => {
  switch (action.type) {
    //Cases for Fire class dropdown
    case SET_ALL_FIRE_CLASS:
      return {
        ...state,
        fireClasses: action.payload,
        isFireClassDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };
    //Cases for Fire class dropdown

    default:
      return state;
  }
};

export default fireClass;
